import wrap from 'wraptile';
import {toggleFullscreen} from '@pluto/fullscreen/fullscreen';
import {SeekMode, TimeFormat} from '@accurate-player/accurate-player-core';
import {PlayerRef} from 'VideoAudioQC/AccuratePlayer/AccuratePlayerTypes';
import {CreateSnapshotAction} from 'VideoAudioQC/QCTabs/Snapshots/Redux/SnapshotActions';

export const onFullscreen = wrap((playerRef: PlayerRef) => {
    const player = playerRef.current;

    if (!player) {
        return;
    }

    toggleFullscreen(document, player.master);
});

export const onGetSnapshot = wrap(
    (
        playerRef: PlayerRef,
        createSnapshot: CreateSnapshotAction,
        videoFileId: number,
        id: string
    ) => {
        const player = playerRef.current?.api;

        if (!player) return;

        const snapshotFrame = player.getCurrentTime(TimeFormat.Frame);

        createSnapshot(id, Number(snapshotFrame), videoFileId);

        player.pause();
    }
);

export const onTimeStep = wrap(
    (playerRef: PlayerRef, time: number, mode: SeekMode, format: TimeFormat) => {
        const player = playerRef.current?.api;

        if (!player) return;

        player.seek({
            time,
            format,
            mode,
        });

        if (format === TimeFormat.Frame) {
            player.pause();
        }
    }
);

export const onToggleMute = wrap((playerRef: PlayerRef) => {
    const player = playerRef.current;

    if (!player) return;

    player.api.toggleMute();
    // if (player.api.muted) {
    //     player.api.unmute();
    // } else {
    //     player.api.mute();
    // }
});
